import { ADEQUACY_OUTCOME_ORDER } from "@app/projects/network-assessment/multi-map-export/utils/adequacyFilterOptions";
import { MultiMapExportAdequacyOutcome } from "@app/projects/network-assessment/multi-map-export/interfaces";
import { toggleOption } from "@app/projects/network-assessment/multi-map-export/utils/mapContentSelection";

export const toggleAdequacyOutcome = (
  selectedOutcomes: readonly MultiMapExportAdequacyOutcome[],
  outcome: MultiMapExportAdequacyOutcome,
  isSelected: boolean,
): MultiMapExportAdequacyOutcome[] => toggleOption(selectedOutcomes, outcome, isSelected, ADEQUACY_OUTCOME_ORDER);
